import { Icon, Tooltip, Box, Text } from "@chakra-ui/react";
import { CheckCircleIcon, TimeIcon, WarningIcon } from "@chakra-ui/icons";
import {
  getEvvStatus,
  EmednyVisitSubmission,
  TellusVisitSubmission,
  SandataVisitSubmission,
  HHAExchangeVisitSubmission,
} from "../utils/evv-status";

interface EvvStatusCellProps {
  clockinTime: string | null;
  clockoutTime: string | null;
  evvAggregator: string | null;
  emednySubmission: EmednyVisitSubmission | null;
  tellusSubmission: TellusVisitSubmission | null;
  sandataSubmission: SandataVisitSubmission | null;
  hhaexchangeSubmission: HHAExchangeVisitSubmission | null;
}

export function EvvStatusCell({
  clockinTime,
  clockoutTime,
  evvAggregator,
  emednySubmission,
  tellusSubmission,
  sandataSubmission,
  hhaexchangeSubmission,
}: EvvStatusCellProps) {
  const evvInfo = getEvvStatus(
    clockinTime,
    clockoutTime,
    evvAggregator,
    emednySubmission,
    tellusSubmission,
    sandataSubmission,
    hhaexchangeSubmission
  );

  const iconMap = {
    pending: TimeIcon,
    submitted: CheckCircleIcon,
    error: WarningIcon,
  };

  const IconComponent = iconMap[evvInfo.status];

  // Split tooltip by newlines for proper rendering
  const tooltipLines = evvInfo.tooltip.split("\n");

  return (
    <Tooltip
      label={
        <Box>
          {tooltipLines.map((line, index) => (
            <Text key={index} fontSize="sm" whiteSpace="pre-wrap">
              {line}
            </Text>
          ))}
        </Box>
      }
      placement="top"
    >
      <span>
        <Icon as={IconComponent} boxSize={4} color={evvInfo.color} />
      </span>
    </Tooltip>
  );
}
